import { apiClient as api } from "./httpClient";

/**
 * Currículo dos profissionais (RN-213). Reúne o que cada um preencheu em Meu perfil — nada aqui
 * é digitado duas vezes, e a tela é só leitura: o dono do currículo é o profissional.
 */
export interface CurriculumItem {
  /** formacao | experiencia | certificacao | registro */
  kind: string;
  title: string;
  institution: string | null;
  startedAt: string | null;
  endedAt: string | null;
  current: boolean;
  description: string | null;
}

export interface ProfessionalCurriculumRow {
  ueprId: string;
  /** Nulo quando o vínculo ainda não aponta para um usuário — sem ele não há currículo nem foto. */
  userId: string | null;
  name: string;
  professionalTypeId: string | null;
  professionalTypeName: string | null;
  documentProfessional: string | null;
  email: string | null;
  /** Em true, buscar a miniatura em GET /reports/professional-curriculum/{userId}/photo?size=thumb */
  hasPhoto: boolean;
  education: number;
  experience: number;
  certification: number;
  registration: number;
  total: number;
  items: CurriculumItem[];
}

export interface CurriculumTypeSlice {
  label: string;
  professionals: number;
  entries: number;
}

export interface ProfessionalCurriculumReport {
  items: ProfessionalCurriculumRow[];
  professionals: number;
  withCurriculum: number;
  withoutCurriculum: number;
  totalEntries: number;
  byType: CurriculumTypeSlice[];
}

export interface ProfessionalCurriculumFilters {
  search?: string;
  professionalTypeId?: string;
  onlyWithCurriculum?: boolean;
}

export const professionalCurriculumService = {
  get: async (filters: ProfessionalCurriculumFilters): Promise<ProfessionalCurriculumReport> => {
    const response = await api.get("/reports/professional-curriculum", {
      params: {
        ...(filters.search ? { search: filters.search } : {}),
        ...(filters.professionalTypeId ? { professionalTypeId: filters.professionalTypeId } : {}),
        ...(filters.onlyWithCurriculum ? { onlyWithCurriculum: true } : {}),
      },
    });
    return response.data;
  },

  /** Proxy autenticado do MinIO — a foto não tem URL pública. */
  photoUrl: async (userId: string, thumb: boolean): Promise<string> => {
    const response = await api.get(
      `/reports/professional-curriculum/${userId}/photo${thumb ? "?size=thumb" : ""}`,
      { responseType: "blob" },
    );
    return URL.createObjectURL(response.data);
  },
};
